class DVTableController {
    constructor(
    // Angular services
    $timeout, $window, $routeParams, $location, $localStorage, 
    // Third party services
    toastr, Upload, 
    // App services
    UserDetailsApi, DataValidatorServiceApi, SettingsExService, TraceHubExService, DownloadXmlExService, ClearingServiceApi, UtpSimServiceApi) {
        this.componentName = 'dv-table';
        this.$onInit = () => {
            this.init();
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop(this.componentName);
        };
        this.downloadClearingFile = (id) => {
            if (id !== null) {
                this.DownloadXmlExService.downloadClearingFile(id);
            }
            else {
                this.toastr.error('Invalid request id');
            }
        };
        this.downloadTraceFile = (traceFileId) => {
            if (traceFileId !== null) {
                this.DownloadXmlExService.downloadTraceFile(traceFileId);
            }
            else {
                this.toastr.error('Invalid request id');
            }
        };
        this.resendClearing = (fileId) => {
            this.ClearingServiceApi.resendClearingValidationRequest(fileId).then((response) => {
                if (response.data.errors.length === 0) {
                    this.toastr.info('Clearing validation request resent');
                    return true;
                }
                else {
                    for (let error of response.data.errors) {
                        this.toastr.error(error);
                    }
                    return false;
                }
            });
        };
        this.init = () => {
            this.data = {
                fileRows: [],
                pagedRows: [],
                currentPage: 1,
                itemsPerPage: 10,
                maxSize: 1,
                totalItems: 0,
                totalPageCount: 0
            };
            this.SettingsExService.getSettings().then((response) => {
                this.appSettings = response.data;
                this.TraceHubExService.connectWithSpecificTransport(this.componentName, this.appSettings.SignalRTransport);
                this.TraceHubExService.on(this.componentName, 'onInit', (connId) => {
                    this.state.connectionId = connId;
                });
                this.TraceHubExService.on(this.componentName, 'onNewDvFiles', (dto) => {
                    if (dto.ConnectionId !== this.state.connectionId) {
                        return;
                    }
                    let dvFileRows = dto.DvFiles;
                    this.data.fileRows = dvFileRows;
                    this.data.totalItems = dvFileRows.length;
                    // As new files arrived so forget current page and reset to page 1
                    this.data.currentPage = 1;
                    this.setPagingRows(this.data.currentPage);
                    this.state.selectedRow = dvFileRows[0];
                });
            });
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                let testerId = 0;
                if (connectedUser.IsDataValidator || connectedUser.IsTester || connectedUser.IsGroupTester) {
                    testerId = connectedUser.Id;
                }
                else {
                    if (this.$routeParams.testerId) {
                        // testerId if coming from DV
                        testerId = this.$routeParams.testerId;
                    }
                    else if (this.$routeParams.userId) {
                        // userId if coming from project testing
                        testerId = this.$routeParams.userId;
                    }
                }
                let simId = 0;
                if (this.$routeParams.simId) {
                    simId = this.$routeParams.simId;
                }
                this.state = {
                    connectedUser: connectedUser,
                    testerId: testerId,
                    connectionId: '',
                    showResend: false,
                    simId: simId,
                    simIsActive: false,
                    selectedRow: null,
                    errorMsg: '',
                    fileType: this.fileType,
                    clearingSimId: this.clearingSimId,
                    clearingSimIsActive: false
                };
                // First time through we initialise the selectedRow
                this.getRows(this.state.testerId, this.state.simId).then((dvFileRows) => {
                    this.data.fileRows = dvFileRows;
                    this.data.totalItems = dvFileRows.length;
                    this.setPagingRows(this.data.currentPage);
                    this.getSavedRowOrFirst(dvFileRows).then((savedRowOrFirst) => {
                        this.state.selectedRow = savedRowOrFirst;
                    });
                });
                if (this.state.fileType && this.state.fileType.toLowerCase() === 'clearing') {
                    if (this.state.clearingSimId > 0) {
                        this.UtpSimServiceApi.isSimulatorRunning(this.state.testerId, this.state.clearingSimId).then((response) => {
                            this.state.clearingSimIsActive = response.data;
                        });
                    }
                }
                else {
                    this.DataValidatorServiceApi.simIsActive(testerId, simId).then((response) => {
                        this.state.simIsActive = response.data;
                    });
                }
            });
        };
        this.pageChanged = () => {
            this.setPagingRows(this.data.currentPage);
        };
        this.changePageSize = (size) => {
            this.data.itemsPerPage = size;
            this.setPagingRows(this.data.currentPage);
        };
        // NOTE: When we return from TraceSummary we reselect the selected row
        this.getRow = () => {
            return this.$timeout(() => {
                // Get the node from the localstorage with key mtNodeStore
                let dvFile = this.$localStorage.dvFile;
                return dvFile || null;
            });
        };
        this.getRows = (testerId, simId) => {
            return this.DataValidatorServiceApi.simulatorDvFilesForUser(testerId, simId).then((response) => {
                let dvFileRows = response.data;
                return dvFileRows;
            });
        };
        this.setPagingRows = (index) => {
            let pagedData = [];
            if (this.data.itemsPerPage < this.data.fileRows.length) {
                pagedData = this.data.fileRows.slice((index - 1) * this.data.itemsPerPage, index * this.data.itemsPerPage);
            }
            else {
                pagedData = this.data.fileRows.slice(0);
                this.data.currentPage = 1;
            }
            let pageCount = Math.ceil(this.data.totalItems / this.data.itemsPerPage);
            this.data.totalPageCount = pageCount;
            this.data.pagedRows = pagedData;
        };
        this.getSavedRowOrFirst = (dvFileRows) => {
            return this.getRow().then((response) => {
                let savedRow = response;
                return savedRow || dvFileRows[0];
            });
        };
        this.selectRow = (row) => {
            this.state.selectedRow = row;
        };
        // NOTE: When we navigate to Trace Summary we save the selected row to local storage
        this.putRow = (dvFile) => {
            this.$timeout(() => {
                this.$localStorage.dvFile = dvFile;
            });
        };
        this.showResend = (row, connectedUser) => {
            // For now, support for the resend only available for DV users
            return connectedUser.IsDataValidator;
        };
        this.duration = (dt) => {
            let now = moment();
            let then = moment(dt);
            return now.diff(then, 'hours');
        };
        this.ago = (dt) => {
            const utc = moment.utc(dt);
            const local = moment(utc).local();
            return moment(local).fromNow();
        };
        this.historyBack = () => {
            this.$window.history.back();
        };
        this.viewFile = (file) => {
            this.traceSummary(file);
        };
        this.traceSummary = (file) => {
            // For DataValidator or Support roles
            if (!file.Id) {
                this.toastr.info('No traces available');
                return;
            }
            this.putRow(file);
            let url = '';
            if (this.state.connectedUser.IsTester || this.state.connectedUser.IsGroupTester) {
                url = `TraceSummaryDV/${file.Id}`;
            }
            else if (this.state.connectedUser.IsDataValidator) {
                url = `TraceSummary/Uid/${file.Id}`;
            }
            else {
                url = `DataValidator/${file.UserId}/Uid/${file.Id}`;
            }
            this.$location.path(url);
        };
        this.deleteFile = (file) => {
            this.toastr.warning('deleteFile Not implemented');
        };
        this.checkFileSizes = (files) => {
            let fac = {
                tooLarge: [],
                validFiles: []
            };
            angular.forEach(files, (file) => {
                let fileSizeMb = file.size / 1024 / 1024;
                if (fileSizeMb <= this.appSettings.MaxUploadMb) {
                    fac.validFiles.push(file);
                }
                else {
                    fac.tooLarge.push(file);
                    let errorMsg = file.name + ': File is too large. Please select a file less than ' +
                        this.appSettings.MaxUploadMb +
                        'MB.';
                    this.toastr.error(errorMsg);
                }
            });
            return fac;
        };
        this.uploadFiles = (files) => {
            if (!files || files.length === 0) {
                return;
            }
            let file = files[0];
            if (!this.validExtension(file.name)) {
                this.toastr.warning('This is an invalid file to upload.  You can only upload files with extension(s):' + this.appSettings.ValidSimulatorExtensions + '.');
                return;
            }
            // File sizes
            // TODO: Display the result in the UI
            let fac = this.checkFileSizes(files);
            if (fac.tooLarge && fac.tooLarge.length > 0) {
                return;
            }
            // Upload files NB Only one at the moment
            this.toastr.info('Uploading file...');
            this.Upload.upload({
                method: 'post',
                url: 'api/DataValidator/UploadFile',
                data: { Files: files }
            }).then((response) => {
                // success
                let success = response.data;
                let msg = success
                    ? 'Files uploaded'
                    : 'No files were uploaded';
                this.getRows(this.state.testerId, this.state.simId).then((dvFileRows) => {
                    this.data.fileRows = dvFileRows;
                    this.state.selectedRow = dvFileRows[0];
                });
                this.toastr.info(msg);
            }, (response) => {
                // error
                if (response.status > 0) {
                    this.state.errorMsg = response.data.ExceptionMessage;
                    this.toastr.error(this.state.errorMsg);
                }
            });
        };
        this.resendFile = (file) => {
            this.toastr.info(`Resending file ${file.FileName}...`);
            this.DataValidatorServiceApi.resendFile(file.Id, this.state.simId).then((response) => {
                // success
                let successMsg = response.data;
                let msg = successMsg
                    ? 'Files submitted for processing'
                    : `Resend failed for file ${file.FileName}`;
                this.getRows(this.state.testerId, this.state.simId).then((dvFileRows) => {
                    this.data.fileRows = dvFileRows;
                });
                this.toastr.info(msg);
            }, (response) => {
                // error
                if (response.status > 0) {
                    this.state.errorMsg = response.data;
                }
            });
        };
        // Test file
        this.validExtension = (fileName) => {
            // If nothing is set in invalid extensions we return true - so dont check.
            if (!this.appSettings.ValidSimulatorExtensions || this.appSettings.ValidSimulatorExtensions === '') {
                return true;
            }
            // Get the file extension
            let arr = fileName.split('.');
            if (arr.length === 1) {
                return false;
            }
            // Get the extension last part of split length - 1
            let extension = arr[arr.length - 1];
            let extArray = this.appSettings.ValidSimulatorExtensions.split(',');
            // Test extension is in invalid Extension list and return converse!
            for (let i = 0; i < extArray.length; i++) {
                if (extArray[i] === extension) {
                    return true;
                }
            }
            return false;
        };
        this.$timeout = $timeout;
        this.$window = $window;
        this.$routeParams = $routeParams;
        this.$location = $location;
        this.$localStorage = $localStorage;
        this.toastr = toastr;
        this.Upload = Upload;
        this.UserDetailsApi = UserDetailsApi;
        this.DataValidatorServiceApi = DataValidatorServiceApi;
        this.SettingsExService = SettingsExService;
        this.TraceHubExService = TraceHubExService;
        this.DownloadXmlExService = DownloadXmlExService;
        this.ClearingServiceApi = ClearingServiceApi;
        this.UtpSimServiceApi = UtpSimServiceApi;
    }
}
angular.module('app').component('dvTable', {
    bindings: {
        fileType: '<',
        clearingSimId: '<'
    },
    templateUrl: 'scripts/app/partials/DataValidator/dv-table.tpl.html',
    controllerAs: 'vm',
    controller: DVTableController
});
